import styled from 'styled-components'

export const ModalMainDiv = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0px;
  right: 0px;
  width: 100vw;
  height: 100vh;
`;
export const ModalDiv = styled.div`
  max-width: 400px;
  position: fixed;
  z-index: 501;
  background-color: white;
  border-radius: 12px;
  box-shadow: 1px 1px 1px black;
  padding: 24px;
  box-sizing: border-box;
  transition: all 0.3s ease-out;
  font-family: sans-serif;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
export const ModalWrapDiv = styled.div`
  background-color: rgba(0, 0, 0, 0.7);
  width: 100vw;
  height: 100vh;
  position: fixed;
  z-index: 500;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
`;
export const HeadingDiv = styled.div`
  font-family: sans-serif;
  font-weight: bold;
  font-size: 16px;
  color: #000000;
  padding: 20px 0px 10px 0px;
  display: flex;
  flex-direction: column;
`;
export const SaveWrapDiv = styled.div`
  width: 100%;
  padding-top: 30px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  & button {
    width: 48%;
    height: 50px;
    border-radius: 8px;
    font-weight: 600;
    font-size: 16px;
    line-height: 19px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
`;
export const SaveButton = styled.button`
  color: #ffffff;
  background-color: #1B49EA;
`;
export const CancelButton = styled.button`
  color: #1B49EA;
  background-color: #edf0fe;
`;
